export const siteConfig = {
    title: "RateMyCoq",
    description: "Personally...10/10",
    image: "./src/Logo.png",
    url: "https://ratemycoq.com",
    imageWidth: '1200',
    imageHeight: '630',
    twitterHandle: '@ratemycoq'
}